"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pageLoad_constant_1 = require("../constants/pageLoad.constant");
var PageLoadDataService = (function () {
    function PageLoadDataService() {
    }
    PageLoadDataService.buildPageName = function (data) {
        var domain = window.location.hostname.split('.')[0];
        var pageName = "".concat(pageLoad_constant_1.default.countryCode, ":").concat(pageLoad_constant_1.default.language, ":").concat(pageLoad_constant_1.default.siteDescriptor, ":").concat(pageLoad_constant_1.default.platform, ":").concat(domain, ":").concat(data.siteSection1);
        if (data.siteSection2) {
            pageName += ":".concat(data.siteSection2);
            if (data.subPage1) {
                pageName += ":".concat(data.subPage1);
                if (data.subPage2) {
                    pageName += ":".concat(data.subPage2);
                }
            }
        }
        return pageName;
    };
    PageLoadDataService.buildPageData = function (data) {
        PageLoadDataService.pageName = PageLoadDataService.buildPageName(data);
        var pageUrl = document.URL;
        return {
            pageTitle: data.pageTitle,
            pageName: PageLoadDataService.buildPageName(data),
            platform: pageLoad_constant_1.default.platform,
            siteSection1: data.siteSection1,
            siteSection2: data.siteSection2,
            siteIdentifier: pageUrl.indexOf('iami') > -1 ? 'iigi' : 'iig',
            is404: data.is404 || pageLoad_constant_1.default.is404,
            pageTemplate: data.pageTemplate,
            DLVersion: pageLoad_constant_1.default.DLVersion
        };
    };
    PageLoadDataService.pageName = '';
    return PageLoadDataService;
}());
exports.default = PageLoadDataService;
